module.exports = __webpack_public_path__ + "static/PaperPlan-5227c197c57dfb3672afbdd9e119f10e.png";